import React, { useState } from "react";
import "./About.css";

const Vasagarvattam = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Sample data - replace with your actual content
  const sections = [
    {
      title: "அமைப்பின் நோக்கங்கள்",
      content: "We strive to deliver excellence in everything we do.",
      images: ["vv1.jpg"]
    },
    {
      title: "மாணவர்களிடையே மக்கள் சிந்தனைப் பேரவையின் பணிகள் - முயற்சிகள்",
      content: "Meet the talented individuals behind our success.",
      images: ["vv2.jpg"]
    },
    {
      title: "பாரதி விழா",
      content: "Established in 2010, we've been growing ever since.",
      images: ["vv3.jpg"]
    },
    {
      title: "ஆசிரியர் பாராட்டு விழா",
      content: "State-of-the-art equipment for optimal results.",
      images: ["vv4.jpg"]
    }
  ];

  const openImage = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = "hidden"; // Prevent scrolling when modal is open
  };

  const closeImage = () => {
    setSelectedImage(null);
    document.body.style.overflow = "auto"; // Re-enable scrolling
  };

  return (
    <div className="about-container">
      {sections.map((section, index) => (
        <div
          key={index}
          className={`section ${index % 2 === 0 ? "even" : "odd"}`}
        >
          {/* <h2 className="section-title">{section.title}</h2> */}
          {/* <p className="section-content">{section.content}</p> */}

          <div
            className={`image-grid ${
              section.images.length > 1 ? "multiple-images" : "single-image"
            } ${
              section.images.length === 4 ? "four-images" : ""
            }`}
          >
            {section.images.map((image, imgIndex) => (
              <div
                key={imgIndex}
                className="image-container"
                onClick={() => openImage(image)}
              >
                <img
                  src={`https://makalukkaga.mpeoplesnet.com/vv/${image}`}
                  alt={`${section.title} ${imgIndex + 1}`}
                  className="section-image"
                />
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* Fullscreen image modal */}
      {selectedImage && (
        <div className="image-modal" onClick={closeImage}>
          <div className="modal-content">
            <img
              src={`https://makalukkaga.mpeoplesnet.com/vv/${selectedImage}`}
              alt="Fullscreen"
              className="fullscreen-image"
            />
            <button className="close-button" onClick={closeImage}>
              &times;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Vasagarvattam;